export type VoteOption = VoteOptionSettings & Partial<VoteOptionData>;
export interface VoteOptionSettings extends Omit<VoteGroupData, 'voteOptions'> {
  position: number;
  region: number;
  roundId: number;
  positionInMatchup: number;
  statistics?: {
    percentage: number;
  };
}
export interface VoteOptionData {
  referenceId: string;
  name: string;
  displayName: string;
  description1: string;
  image: string;
  videoEmbed: string;
  externalLinkHref: string;
  externalLinkText: string;
  schema_reference: string;
}

export interface VoteGroupData {
  is_active: boolean;
  match_up_id: number;
  vote_options: VoteOptionData[] | {}[];
  round_id: number;
  vote_group_id: string;
  parent_vote_group_id: string | null;
}

export interface VoteData {
  voteGroups: VoteGroupData;
  rounds: {
    roundId: number;
    isActive: boolean;
  }[];
}

export interface PropertyName {
  name: string;
  reference: string;
  text: string;
}

export const SnapshotType = {
  OPEN: 'open',
  CLOSED: 'closed',
  WINNER: 'winner',
} as const;

// eslint-disable-next-line -- intentionally naming the object the same as the type
export type SnapshotType = typeof SnapshotType[keyof typeof SnapshotType];

export const ErrorType = {
  GEO: 'geo',
  GENERIC: 'generic',
  OVERLIMIT: 'overlimit',
  WINDOW: 'window',
  FB_PERMISSIONS: 'fbPermissions',
  FB_GENERIC: 'fbGeneric',
  APPLE_PRIVATE_RELAY: 'apr',
} as const;

// eslint-disable-next-line -- intentionally naming the object the same as the type
export type ErrorType = typeof ErrorType[keyof typeof ErrorType];

export interface AdUnitData {
  isEnabled: boolean;
  altText: string;
  imageUrl: string;
  linkUrl: string;
}
